import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const CondeNast = ({featuredProjectsList}) => {
  const project = getProject('conde-nast');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '215916974'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="a-publisher-s-first">A publisher’s first</h2>
          <p>
            A real-time hub of all their brands’ news and Twitter feeds - made
            customizable to user preference.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170505230912/cn-slide4.jpg'
          }}
        />

        <Quote
          className="g-row quote--marks"
          component={{
            quote:
              'This redesign embodies the soul of today’s Condé Nast: its indispensable editorial, exceptional talent, cutting-edge client services and a legacy that is second to none.',
            quotee: 'Charles H. Townsend, CEO'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="helping-advertisers-navigate">
            Helping advertisers navigate
          </h2>
          <p>Extensive media kits conveying brand pulse including:</p>
          <ul>
            <li>Up-to-date reach.</li>
            <li>Magazine, sector, and digital placement customizer.</li>
            <li>Brand news and social feeds, apps and contacts.</li>
          </ul>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170505230644/cn-slide3.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="a-nod-to-the-past-and-present">
            A nod to the past, and present
          </h2>
          <p>
            Celebrating the heritage of Mr. Condé Montrose Nast with highlights
            from establishing as a publisher in 1909, to the premier media
            company it is today.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170505230643/cn-slide2.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170505230645/cn-slide5.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>166.67% increase in monthly unique visitors.</li>
            <li>10 awards for best in corporate communication.</li>
          </ul>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Content Strategy',
                  'Launch Strategy',
                  'Technical Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Integration Support',
                  'Launch',
                  'Monitoring',
                  'Optimization',
                  'Quality Assurance',
                  'Staff Training & Support'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default CondeNast;
